import React from "react"
import { connect } from "react-redux"
import { startNewUpload } from "../state/modules/upload"
import { useTimelineEventData } from "./TimelineEventDataProvider"
import ClickArea from "./styled/ClickArea"

const RestartableTransfer = ({ children, className, startNewUpload }) => {
  const {
    uploadState: { isUploading, isQueued },
  } = useTimelineEventData()

  const canClick = !(isUploading || isQueued)

  return (
    <ClickArea
      className={className}
      $canClick={canClick}
      onClick={canClick ? startNewUpload : null}
    >
      {children}
    </ClickArea>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    startNewUpload: e => {
      e.stopPropagation()
      dispatch(startNewUpload())
    },
  }
}

export default connect(null, mapDispatchToProps)(RestartableTransfer)
